var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8691 0.924231C13.2685 1.42739 12.5628 1.90406 12.2926 1.99675C11.8572 2.16888 11.8271 2.2086 11.8271 2.88389C11.8271 3.28112 11.8572 3.5989 11.9022 3.5989C12.1424 3.5989 13.1484 3.14871 13.5838 2.85741L14.0793 2.52639V3.32084V4.12854H15.5807H17.0821V2.53963C17.0821 0.831544 16.9469 0.394593 16.3764 0.169497C15.5206 -0.174768 15.0402 -0.0291176 13.8691 0.924231Z",
    fill: "url(#paint0_linear_1740_4279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28431 6.39277C1.52766 9.83541 0.0562857 12.7219 0.0112435 12.8279C-0.0488127 12.9735 0.116342 13 0.88206 12.9735L1.82795 12.9338L2.62369 11.4111L3.40442 9.88838L6.45228 9.84865L9.50013 9.82217L10.3109 11.4111L11.1217 13H12.1426H13.1636L12.3528 11.4376C11.9174 10.5901 10.401 7.70362 9.00467 5.01571L6.46729 0.156282L3.28431 6.39277ZM7.60836 6.08823C8.19391 7.27991 8.67436 8.29946 8.67436 8.37891C8.67436 8.51132 4.44039 8.55104 4.29025 8.41863C4.24521 8.37891 4.63558 7.47853 5.17608 6.40601C5.71659 5.33349 6.21205 4.31394 6.28712 4.14181C6.3622 3.96968 6.45228 3.85051 6.48231 3.87699C6.51234 3.90347 7.0078 4.89654 7.60836 6.08823Z",
    fill: "url(#paint1_linear_1740_4279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2444 9.74306L14.1993 7.13459L14.1543 4.52612H15.5956H17.037L17.1271 7.00218L17.2022 9.49148L16.5265 11.0804C16.1512 11.9543 15.7908 12.709 15.7458 12.7752C15.6857 12.8282 15.3254 12.1661 14.95 11.3055L14.2444 9.74306ZM15.0809 10.286L15.731 11.6763L16.3812 10.286H15.0809Z",
    fill: "url(#paint2_linear_1740_4279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1740_4279",
    x1: 11.8271,
    y1: 4.12854,
    x2: 15.8385,
    y2: -0.977119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4081BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1740_4279",
    x1: 0,
    y1: 13,
    x2: 12.8398,
    y2: -0.159586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4081BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1740_4279",
    x1: 14.1543,
    y1: 4.52612,
    x2: 19.5183,
    y2: 6.50728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4081BF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0218303d067aa8d13adba0355b1e91af.svg";
export { ForwardRef as ReactComponent };